// extracted by mini-css-extract-plugin
export var completionBody = "_ma-2";
export var completionCard = "_ma-0";
export var completionFooter = "_ma-3";
export var completionTitle = "_ma-1";